<template>
  <main-template>
    <v-row>
      <v-col>
        <h2>
          <v-btn color="primary" x-small text @click="$router.back()">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          DESEMPENHO PEDAGÓGICO - ALUNO
          <span class="meu-componente-especial">
            <e-help-tooltip :text="$constants.tooltips.desempenhoPedagogico.desempenhoAluno" />
          </span>
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          prepend-icon="mdi-school"
          v-model="escola"
          :items="franquias.filter((item) => !item.deleted_at)"
          item-text="descricao"
          item-value="id"
          dense
          return-object
          filled
          color="teal darken-1"
          label="Selecione uma escola"
          @change="loadDesempenho(escola.id)"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-row v-if="carregando">
      <v-col cols="12">
        <div class="text-center mb-4">
          <v-icon color="primary" class="mb-2">mdi-loading mdi-spin</v-icon>
          <p class="text-body-2 text-medium-emphasis">Aguarde, isso pode demorar...</p>
        </div>

        <v-card class="mb-3" v-for="n in 3" :key="n" elevation="1">
          <v-card-text>
            <div class="d-flex align-center mb-3">
              <v-skeleton-loader type="avatar" class="me-3"></v-skeleton-loader>
              <div class="flex-grow-1">
                <v-skeleton-loader type="heading" class="mb-1" width="60%"></v-skeleton-loader>
                <v-skeleton-loader type="subtitle" width="40%"></v-skeleton-loader>
              </div>
              <v-skeleton-loader type="chip" width="80px"></v-skeleton-loader>
            </div>
            <v-skeleton-loader type="paragraph" class="mb-2"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else-if="turmas.length === 0">
      <v-col cols="12">
        <v-alert type="info" text>
          Nenhum dado de desempenho encontrado para a escola selecionada.
        </v-alert>
      </v-col>
    </v-row>

    <div v-else>
      <v-tabs v-model="tab" background-color="transparent" color="teal darken-1" grow>
        <v-tab href="#alunos">
          <v-icon left>groups</v-icon>
          Desempenho dos Alunos
        </v-tab>
        <v-tab href="#relatorios">
          <v-icon left>query_stats</v-icon>
          Relatórios de Desempenho (Aluno)
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="mt-4">
        <v-tab-item value="alunos">
          <v-card>
            <v-card-title>
              <span class="text-h6">Turmas:</span>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar Turma"
                single-line
                hide-details
                dense
                class="ml-4 mt-6 mr-6 mb-3"
                style="max-width: 350px"
              ></v-text-field>
            </v-card-title>

            <v-card-text>
              <v-expansion-panels>
                <turma-expansion-item
                  v-for="turma in turmasPaginadas"
                  :key="turma.id"
                  :turma="turma"
                  class="mb-4"
                />
              </v-expansion-panels>
            </v-card-text>

            <e-paginate
              v-if="totalPages > 1"
              :current_page="currentPage"
              :last_page="totalPages"
              :page-number="currentPage"
              :search="searchTerm"
              @changeActionResponse="handlePageChange"
              class="mt-4 mb-4"
            />
          </v-card>
        </v-tab-item>

        <v-tab-item value="relatorios">
          <v-card>
            <v-card-text class="d-flex justify-start align-center flex-wrap">
              <v-col cols="12" sm="6" md="4">
                <v-card color="teal darken-1" dark @click="relatorioPorFranquia">
                  <v-card-title>
                    <v-icon large left>groups</v-icon>
                    <span class="title font-weight-light">Relatório Desempenho</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold">por Franquia</v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-card color="teal darken-1" dark @click="relatorioPorTurma">
                  <v-card-title>
                    <v-icon large left>groups</v-icon>
                    <span class="title font-weight-light">Relatório Desempenho</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold">por Turma</v-card-text>
                </v-card>
              </v-col>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <e-modal-turmas-franquia
      :dialog="dialogTurmasFranquia"
      :franquia_id="escola.id"
      @dialogChange="dialogTurmasFranquia = $event"
      tipo-relatorio="aluno"
    ></e-modal-turmas-franquia>

    <scroll-top
      :threshold="300"
      color="teal darken-1"
      tooltip="Subir ao topo"
      bottom="100"
      right="20"
      :size="60"
      iconColor="white"
    />
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import EPaginate from "@/components/EPaginate.vue";
import TurmaExpansionItem from "./TurmaExpansionItem.vue";

export default {
  name: "DesempenhoPedagogicoAlunoPage",

  components: {
    TurmaExpansionItem,
    EPaginate,
  },

  data() {
    return {
      tab: "alunos",
      escola: {
        id: null,
        descricao: null,
      },
      turmas: [],
      carregando: false,
      currentPage: 1,
      itemsPerPage: 5,
      search: "",
      searchTerm: "",
      franquias: [],
      dialogTurmasFranquia: false,
    };
  },

  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquiasList"]),

    turmasFiltradas() {
      if (!this.search) {
        return this.turmas;
      }
      const termo = this.search.toLowerCase().trim();
      return this.turmas.filter((turma) => (turma.descricao || "").toLowerCase().includes(termo));
    },

    totalPages() {
      return Math.ceil(this.turmasFiltradas.length / this.itemsPerPage);
    },

    turmasPaginadas() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.turmasFiltradas.slice(start, start + this.itemsPerPage);
    },
  },

  watch: {
    search() {
      this.currentPage = 1;
    },
  },

  async mounted() {
    await this.loadData();
    if (this.escola.id) {
      await this.loadDesempenho(this.escola.id);
    }
  },

  methods: {
    async loadData() {
      await this.$services.franquiasService.syncAll();
      this.escola.id = this.user.franquia.id;
      this.escola.descricao = this.user.franquia.descricao;

      if (!this.user.franquias_permitidas) {
        this.franquias = [...this.franquiasList];
        return;
      }

      (this.franquiasList || []).forEach((franq) => {
        if (this.user.franquias_permitidas?.includes(franq.id)) {
          this.franquias.push(franq);
        }
      });
    },

    async loadDesempenho(escolaId) {
      if (!escolaId) return;

      this.carregando = true;
      try {
        const response = await this.$services.usabilidadeService.getAlunosUsabilidade(escolaId);
        this.turmas = response?.turmas || [];
        this.currentPage = 1;
        this.search = "";
      } catch (error) {
        this.turmas = [];
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },

    handlePageChange(page, searchTerm) {
      this.currentPage = page;
      this.searchTerm = searchTerm;
    },

    async relatorioPorFranquia() {
      if (!this.escola.id) return;
      this.$loaderService.open("Gerando relatório... Isso pode demorar um pouco.");
      try {
        await this.$services.relatoriosService.DesempenhoAlunoPorFranquia(this.escola.id);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    relatorioPorTurma() {
      this.dialogTurmasFranquia = true;
    },
  },
};
</script>

<style scoped>
.meu-componente-especial {
  display: inline-block;
}
</style>
